// extracted by mini-css-extract-plugin
export var actionBox = "payment-module--action-box--6b18e";
export var button = "payment-module--button--4187d";
export var container = "payment-module--container--ed9b4";
export var dateText = "payment-module--date-text--c25c9";
export var infoBox = "payment-module--info-box--84c00";
export var statusText = "payment-module--status-text--026f7";